import {RichText, RichTextTextStyle} from '@gongxigames/framework/core/fragments/display';

const styles: RichTextTextStyle | Partial<RichTextTextStyle> = {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 65,
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center'
};

RichText.setStyle('AutoplayPopupToggleButtonTitle', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 65,
    fontWeight: 'bold',
    align: 'left',
    fill: '#ffffff',
    wordWrapWidth: 500,
    wordWrap: true
});

RichText.setStyle('AutoplayPopupText', {
    ...styles
});

RichText.setStyle('AutoplayPopupBetText', {
    ...styles,
    align: 'left',
    textTransform: 'uppercase'
});

RichText.setStyle('AutoplayPopupConfirmationTitle', {
    ...styles,
    fontSize: 120,
    textTransform: 'uppercase'
});

RichText.setStyle('AutoplayPopupConfirmationText', {
    ...styles,
    textTransform: 'uppercase',
    wordWrap: true,
    wordWrapWidth: 1350
});

RichText.setStyle('AutoplayPopupStartButtonText', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 130,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center'
});

RichText.setStyle('AutoplayPopupRoundsOptionText', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 120,
    fontWeight: 'bold',
    align: 'center',
    fill: '#ffffff',
    verticalAlign: 'center'
});
